module.exports = __webpack_public_path__ + "img/m_logo.dd2dff09.png";